import { useState } from "react";
import { ExcelData } from "@/lib/types";
import { Collection } from "@/lib/api";
import FileUpload from "@/components/FileUpload";
import CollectionManager from "@/components/CollectionManager";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";

interface SidebarProps {
  onFileLoaded: (data: ExcelData) => void;
  onCollectionSelect: (collection: Collection) => void;
  selectedCollection: Collection | null;
}

const Sidebar = ({ onFileLoaded, onCollectionSelect, selectedCollection }: SidebarProps) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <div
      className={`fixed left-0 top-0 h-full bg-white border-r transition-all duration-300 ${
        isCollapsed ? "w-16" : "w-80"
      }`}
    >
      <div className="h-full flex flex-col">
        {/* Collapse button */}
        <Button
          variant="ghost"
          size="icon"
          className="absolute -right-4 top-4 bg-white border rounded-full shadow-sm"
          onClick={() => setIsCollapsed(!isCollapsed)}
        >
          {isCollapsed ? (
            <ChevronRight className="h-4 w-4" />
          ) : (
            <ChevronLeft className="h-4 w-4" />
          )}
        </Button>

        {/* Content */}
        <div className={`flex-1 overflow-y-auto p-4 ${isCollapsed ? "hidden" : ""}`}>
          <h2 className="text-lg font-semibold mb-4">Excel Chat</h2>
          
          <CollectionManager onCollectionSelect={onCollectionSelect} />
          
          {selectedCollection && (
            <div className="mb-4 p-2 bg-blue-50 rounded">
              <p className="text-sm text-blue-700">
                Selected: <span className="font-medium">{selectedCollection.name}</span>
                <span className="ml-2">({selectedCollection.count} docs)</span>
              </p>
            </div>
          )}

          <FileUpload onFileLoaded={onFileLoaded} />
        </div>
      </div>
    </div>
  );
};

export default Sidebar; 